export default __webpack_public_path__ + "images/e89f18371c8d8f293f7cf038288aca5c-state.jpg";